import { render, staticRenderFns } from "./FindOutMoreDialog.vue?vue&type=template&id=2fa6d7d3"
import script from "./FindOutMoreDialog.vue?vue&type=script&lang=ts"
export * from "./FindOutMoreDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports